import { envConfig } from "../../utils/constants";
import { CategoryItemState } from "../../utils/interfaces/categoryInfo";
import { client } from "../graphql";
import { GET_CATEGORY_INFO, GET_ROOT_CATEGORY_ID } from "./queries";

class CategoryInfoServices {
  async fetchCategoryInfo(uid: string): Promise<CategoryItemState> {
    const res = await client.query({
      query: GET_CATEGORY_INFO,
      variables: { uid },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.categories;
  }
  async fetchRootCategoryId(): Promise<CategoryItemState> {
    const res = await client.query({
      query: GET_ROOT_CATEGORY_ID,
      context: { headers: { store: envConfig.store } },
      fetchPolicy: "no-cache",
    });
    return this.fetchCategoryInfo(res.data.storeConfig.root_category_uid);
  }
}

export default new CategoryInfoServices();
